var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4681A0",
    d: "M50 0c27.614 0 50 22.387 50 50 0 27.614-22.386 50-50 50s-50-22.386-50-50c0-27.613 22.386-50 50-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F7490",
    d: "M50 100c13.299 0 25.374-5.201 34.331-13.669 8.468-8.957 13.669-21.032 13.669-34.331 0-11.256-3.722-21.643-10-30h-65c-2.762 0-5 2.238-5 5v61.413c8.671 7.232 19.826 11.587 32 11.587z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M25 20c-2.762 0-5 2.238-5 5v65.001c8.357 6.277 18.743 9.999 30 9.999 27.614 0 50-22.386 50-50 0-11.256-3.722-21.643-10-30h-65z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M100 50c0-3.781-.434-7.459-1.229-11h-78.771v51.001c8.357 6.277 18.743 9.999 30 9.999 27.614 0 50-22.386 50-50z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2574C",
    d: "M29.5 26c1.934 0 3.5 1.567 3.5 3.5 0 1.934-1.566 3.5-3.5 3.5-1.933 0-3.5-1.566-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFC75E",
    d: "M39.5 26c1.934 0 3.5 1.567 3.5 3.5 0 1.934-1.566 3.5-3.5 3.5-1.933 0-3.5-1.566-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3DB39E",
    d: "M49.5 26c1.934 0 3.5 1.567 3.5 3.5 0 1.934-1.566 3.5-3.5 3.5-1.933 0-3.5-1.566-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E7E7",
    d: "M93.869 26h-33.869c-1.104 0-2 .896-2 2v3c0 1.105.896 2 2 2h37.03c-.877-2.426-1.935-4.765-3.161-7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DADADA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 84h13c.553 0 1-.447 1-1s-.447-1-1-1h-13c-.553 0-1 .447-1 1s.447 1 1 1zM77 85c-.553 0-1 .447-1 1v1c0 .553.447 1 1 1h5.477c1.115-.954 2.19-1.953 3.218-3h-8.695zM30 88h16c.553 0 1-.447 1-1s-.447-1-1-1h-16c-.553 0-1 .447-1 1s.447 1 1 1zM28 49v13c0 1.105.896 2 2 2h67.999c1.294-4.444 2.001-9.139 2.001-14 0-1.008-.039-2.007-.098-3h-69.902c-1.104 0-2 .896-2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 76.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 86v1c0 .553.447 1 1 1h13c.553 0 1-.447 1-1v-1c0-.553-.447-1-1-1h-13c-.553 0-1 .447-1 1zM49 78h-19c-.553 0-1 .447-1 1s.447 1 1 1h19c.553 0 1-.447 1-1s-.447-1-1-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 76.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 76h19c.553 0 1-.447 1-1v-2c0-.553-.447-1-1-1h-19c-.553 0-1 .447-1 1v2c0 .553.447 1 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.e52de4be68c4740fb73303d0616313cf.svg";
export { ForwardRef as ReactComponent };